export const environment = {
    production: false,
};

export const API_BASE_URL = 'http://simulador-backend.lndo.site';
